import { render, staticRenderFns } from "./GroupCallStatus.vue?vue&type=template&id=bc4b047c&scoped=true"
import script from "./GroupCallStatus.vue?vue&type=script&lang=js"
export * from "./GroupCallStatus.vue?vue&type=script&lang=js"
import style0 from "./GroupCallStatus.vue?vue&type=style&index=0&id=bc4b047c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4b047c",
  null
  
)

export default component.exports